import { render, staticRenderFns } from "./table-retorno-boleto.vue?vue&type=template&id=d1d20be2&scoped=true&"
import script from "./table-retorno-boleto.vue?vue&type=script&lang=js&"
export * from "./table-retorno-boleto.vue?vue&type=script&lang=js&"
import style0 from "./table-retorno-boleto.vue?vue&type=style&index=0&id=d1d20be2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d20be2",
  null
  
)

export default component.exports